import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { LayoutWrapper } from "./Structur/Aconlayout";
import React from "react";
import dayjs from "dayjs";
//import dayjsDow from 'dayjs/plugin/dow';
import "./locale/de-at"; // Importieren Sie die deutsche Lokalisierung für Day.js
import "dayjs/plugin/timezone"; // Importieren Sie das Timezone-Plugin für Day.js
import utc from 'dayjs/plugin/utc';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


const queryClient = new QueryClient(
  {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime:Infinity,
      cacheTime: 60000, // Cache-Dauer in Millisekunden (hier 1 Minuten)
    },
  },
}
);
function App() {
  // Setzen Sie die Lokalisierung auf Deutsch für Europa
  dayjs.locale("de-at");
  // Erweitern Sie Day.js um das Timezone-Plugin
  dayjs.extend(require("dayjs/plugin/timezone"));
  // Setzen Sie die Standardzeitzone für die App (z. B. Mitteleuropäische Zeit)
  dayjs.tz.setDefault("Europe/Vienna"); // Passen Sie die Zeitzone entsprechend Ihrer Region an
  // Ändern Sie das Datumsformat für das Jahr
  dayjs.extend(require("dayjs/plugin/localizedFormat"));
  //dayjs.localeData().longDateFormat("L").replace("YYYY", "YYYY [Jahr]");
  dayjs.extend(utc);
  document.title = process.env.REACT_APP_PUBLIC_NAME;
  const publicUrl = process.env.REACT_APP_PUBLIC_URL;
  console.log("App wird gestartet - publicUrl", { publicUrl });

  return (
    <div className="App">
       <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={publicUrl}>
        <LayoutWrapper />
      </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}
export default App;

/*
.env
PUBLIC_URL = "/Profi/"
REACT_APP_PUBLIC_NAME="Profi"
REACT_APP_PUBLIC_URL="/Profi"

npm install --save react-copy-to-clipboard
npm i --save copy-to-clipboard

npm install resend
npm install react-email @react-email/components -E

npm install formik

https://github.com/rajinwonderland/react-code-blocks?tab=readme-ov-file
npm i react-code-blocks

*/
